// GET VOUCHER LIST
export const GET_VOUCHER_LIST = 'GET_VOUCHER_LIST';
export const GET_VOUCHER_LIST_SUCCESS = 'GET_VOUCHER_LIST_SUCCESS';
export const GET_VOUCHER_LIST_FAILED = 'GET_VOUCHER_LIST_FAILED';

// GET VOUCHER DETAIL
export const GET_VOUCHER_DETAIL = 'GET_VOUCHER_DETAIL';
export const GET_VOUCHER_DETAIL_SUCCESS = 'GET_VOUCHER_DETAIL_SUCCESS';
export const GET_VOUCHER_DETAIL_FAILED = 'GET_VOUCHER_DETAIL_FAILED';

// CREATE VOUCHER CAMPAIGN
export const CREATE_VOUCHER_CAMPAIGN = 'CREATE_VOUCHER_CAMPAIGN';
export const CREATE_VOUCHER_CAMPAIGN_SUCCESS =
  'CREATE_VOUCHER_CAMPAIGN_SUCCESS';
export const CREATE_VOUCHER_CAMPAIGN_FAILED = 'CREATE_VOUCHER_CAMPAIGN_FAILED';

// UPDATE VOUCHER CAMPAIGN
export const UPDATE_VOUCHER_CAMPAIGN = 'UPDATE_VOUCHER_CAMPAIGN';
export const UPDATE_VOUCHER_CAMPAIGN_SUCCESS =
  'UPDATE_VOUCHER_CAMPAIGN_SUCCESS';
export const UPDATE_VOUCHER_CAMPAIGN_FAILED = 'UPDATE_VOUCHER_CAMPAIGN_FAILED';

// ADD CODE TO VOUCHER CAMPAIGN
export const ADD_CODE_TO_VOUCHER_CAMPAIGN = 'ADD_CODE_TO_VOUCHER_CAMPAIGN';
export const ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS =
  'ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS';
export const ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED =
  'ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED';

// DELETE VOUCHERS FROM CAMPAIGN
export const DELETE_VOUCHERS_FROM_CAMPAIGN = 'DELETE_VOUCHERS_FROM_CAMPAIGN';
export const DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS =
  'DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS';
export const DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED =
  'DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED';

// CLEAR VOUCHER DETAIL
export const CLEAR_VOUCHER_DETAIL = 'CLEAR_VOUCHER_DETAIL';

// DELETE CAMPAIGN
export const DELETE_VOUCHER_CAMPAIGN = 'DELETE_VOUCHER_CAMPAIGN';
export const DELETE_VOUCHER_CAMPAIGN_SUCCESS =
  'DELETE_VOUCHER_CAMPAIGN_SUCCESS';
export const DELETE_VOUCHER_CAMPAIGN_FAILED = 'DELETE_VOUCHER_CAMPAIGN_FAILED';
